import LegalLayout, { LegalSection } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout label="TERMS OF SERVICE" title="Terms of Service" effective="December 2026">
      <p>
        These Terms of Service (&ldquo;Terms&rdquo;) govern your use of
        smallbusinessautomator.com (the &ldquo;Site&rdquo;) and any programs,
        services, or communications provided by Small Business Automator
        (&ldquo;SBA,&rdquo; &ldquo;we,&rdquo; &ldquo;us&rdquo;). By using the Site
        or submitting a form, you agree to these Terms.
      </p>

      <LegalSection heading="1. Use of the Site">
        <p>
          You agree to use the Site lawfully and not to attempt to disrupt, reverse-engineer,
          or gain unauthorized access to any portion of the Site or our systems.
        </p>
      </LegalSection>

      <LegalSection heading="2. Strategy Calls &amp; Programs">
        <p>
          Our strategy calls are provided free of charge. Any paid program you elect to
          purchase after a strategy call is governed by a separate written agreement between
          you and SBA. Nothing on the Site constitutes an offer, guarantee, or contract until
          such written agreement is signed by both parties.
        </p>
      </LegalSection>

      <LegalSection heading="3. SMS / Text Messaging Consent (A2P 10DLC)">
        <p>
          By providing your phone number and opting in, you consent to receive SMS messages
          from Small Business Automator related to your appointment, follow-ups, and any
          services you specifically request.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Message frequency varies.</li>
          <li>Message and data rates may apply.</li>
          <li>Reply <strong>HELP</strong> for help at any time.</li>
          <li>Reply <strong>STOP</strong> to unsubscribe at any time.</li>
          <li>
            Mobile information and opt-in consent are not shared with third parties or
            affiliates for marketing or promotional purposes.
          </li>
        </ul>
        <p>
          If you do not consent to receive text messages, do not submit your phone number
          through the Site.
        </p>
      </LegalSection>

      <LegalSection heading="4. Intellectual Property">
        <p>
          All content on the Site — including copy, brand marks, graphics, video, and code —
          is owned by SBA or licensed to us and is protected by intellectual property laws.
          You may not copy, reproduce, or redistribute Site content without our written
          permission.
        </p>
      </LegalSection>

      <LegalSection heading="5. No Professional Advice">
        <p>
          Information on the Site is provided for general business education purposes and is
          not legal, financial, tax, accounting, mortgage, or investment advice. You are
          responsible for your own business decisions and outcomes.
        </p>
      </LegalSection>

      <LegalSection heading="6. Third-Party Links">
        <p>
          The Site may link to third-party sites. We are not responsible for the content,
          privacy, or security practices of any third-party site.
        </p>
      </LegalSection>

      <LegalSection heading="7. Disclaimers &amp; Limitation of Liability">
        <p>
          The Site and any content, tools, or communications are provided &ldquo;as is&rdquo;
          without warranties of any kind. To the maximum extent permitted by law, SBA is not
          liable for indirect, incidental, consequential, or punitive damages arising from
          your use of the Site or reliance on its content.
        </p>
      </LegalSection>

      <LegalSection heading="8. Governing Law">
        <p>These Terms are governed by the laws of the United States and the state in which SBA is registered, without regard to conflict-of-laws principles.</p>
      </LegalSection>

      <LegalSection heading="9. Changes to These Terms">
        <p>We may update these Terms at any time. Continued use of the Site after changes constitutes acceptance of the updated Terms.</p>
      </LegalSection>

      <LegalSection heading="10. Contact">
        <p>
          Questions? Email <a href="mailto:dallas@smallbusinessautomator.com" className="text-[#C9A84C] hover:underline">dallas@smallbusinessautomator.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
